{
  "__schema": {
    "types": [
      {
        "kind": "INTERFACE",
        "name": "Aliasable",
        "possibleTypes": [
          {
            "name": "Alias"
          },
          {
            "name": "Hospital"
          },
          {
            "name": "Equipment"
          },
          {
            "name": "EquipmentFunction"
          },
          {
            "name": "Medication"
          },
          {
            "name": "Molecule"
          },
          {
            "name": "ProtocolSet"
          },
          {
            "name": "Protocol"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Node",
        "possibleTypes": [
          {
            "name": "Alias"
          },
          {
            "name": "Hospital"
          },
          {
            "name": "Organization"
          },
          {
            "name": "Credential"
          },
          {
            "name": "Equipment"
          },
          {
            "name": "EquipmentFunction"
          },
          {
            "name": "ReferencedSource"
          },
          {
            "name": "User"
          },
          {
            "name": "Seat"
          },
          {
            "name": "Medication"
          },
          {
            "name": "Molecule"
          },
          {
            "name": "ProtocolSet"
          },
          {
            "name": "Protocol"
          },
          {
            "name": "ProtocolStep"
          },
          {
            "name": "Source"
          },
          {
            "name": "SourceVersion"
          },
          {
            "name": "PaymentSubscription"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "OrganizationOwned",
        "possibleTypes": [
          {
            "name": "Hospital"
          },
          {
            "name": "Equipment"
          },
          {
            "name": "Medication"
          },
          {
            "name": "ProtocolSet"
          },
          {
            "name": "Source"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Publishable",
        "possibleTypes": [
          {
            "name": "Hospital"
          },
          {
            "name": "Equipment"
          },
          {
            "name": "EquipmentFunction"
          },
          {
            "name": "Medication"
          },
          {
            "name": "ProtocolSet"
          },
          {
            "name": "Protocol"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "ProtocolDoseConditionOfUse",
        "possibleTypes": [
          {
            "name": "ProtocolDosePatientTypeConditionOfUse"
          },
          {
            "name": "ProtocolDoseNoteConditionOfUse"
          },
          {
            "name": "ProtocolDosePatientAgeConditionOfUse"
          }
        ]
      }
    ]
  }
}
